import React from 'react'
import styles from './style.module.scss'
interface Props {
    Type: string
    Data: string
    Url: string
}

const Icon : React.SFC<Props> = (props) => {
    const Style : string = `${props.Type} fa-${props.Data} ${styles.Icon}`
    return (
        <a href={props.Url}>
            <i className={Style}></i>
        </a>
    )
}

export default Icon